import {
    Analytics,
    getFilterCategoryName,
    ADD_TO_CART_SELECTOR,
    DOWNLOAD_BTN_SELECTOR,
    FILTER_PILL_SELECTOR,
    RESULT_LIST_ITEM,
    CHAT_ONLINE_SELECTOR,
    DOWNLOAD_LABEL,
} from '../../FrontendBuildKit/analytics/analytics';

const { apcLogService } = window;
const safeWrap = prop => (...args) => {
    if (!apcLogService) return null;

    return apcLogService[prop](...args);
};
const PAGE = 'categoryPage';
const HELP_ME_CHOOSE_BTN_SELECTOR = 'a.help-me-choose-analytics';
const SUBCATEGORY_SELECTOR = '.subcategory-analytics';
const CATEGORY_CARD_SELECTOR = '.category-card-analytics';
const RELATED_MEDIA_SELECTOR = '.related-media-analytics';
const FIND_RESELLER_SELECTOR = 'a.find-reseller-analytics';
const SUPPORT_BTN_SELECTOR = 'a.support-analytics';
const TAB_SELECTOR = '.tab-analytics';
const QUICK_LINK_SELECTOR = '.quick-link-analytics';
const HELP_ME_CHOOSE_BANNER = '.help-me-choose-banner';
const SUPPORT_LINK_SELECTOR = 'a[class*="SupportAndServices_linkText"]';

const matchThisOrChildren = safeWrap('matchThisOrChildren');
const getClosest = safeWrap('getClosest');
const preload = safeWrap('preload');
const setPageReady = safeWrap('setPageReady');
const setVariables = safeWrap('setVariables');
const getDefaultPageReadyPromise = safeWrap('getDefaultPageReadyPromise');

const isRootCategory = () => !document.querySelector('.apcCategories[data-root-category]');
const isCategoryLvlTwo = () => {
    const category = document.querySelector('.apcCategories[data-category]');
    return category && category.dataset.category === 'product-category';
};

const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1);

const getCategoryId = () => {
    const parts = document.location.pathname.split('/');
    const isRoot = isRootCategory();
    if (isRoot) {
        return '';
    }
    return parts.pop() || parts.pop();
};
const getBreadCrumbs = () => {
    let breadcrumbsAttr = document.querySelector('.apcCategories [data-breadcrumbs]');
    breadcrumbsAttr = breadcrumbsAttr ? breadcrumbsAttr.dataset.breadcrumbs || '' : '';
    const breadcrumbs = breadcrumbsAttr.split(',').slice(1);
    breadcrumbs.pop();
    return breadcrumbs;
};

const getCurrentCategory = () => {
    const currentCategory = document.querySelector('.apcCategories[data-category]');
    return currentCategory ? currentCategory.dataset.category : '';
};
const getCurrentCategoryName = () => {
    const categoryName = document.querySelector('.apcCategories[data-category-name]');
    return categoryName ? categoryName.dataset.categoryName : '';
};

const setVariablesHandler = (isReloadNeeded = true) => {
    try {
        const breadcrumbs = getBreadCrumbs().slice(1);
        const categoryNames =
            isCategoryLvlTwo() && breadcrumbs.length
                ? `${breadcrumbs.join(',')}_${getCurrentCategoryName()}`
                : getCurrentCategoryName();
        const page_cat1 = isRootCategory() ? '' : getCurrentCategory();
        const page_cat2 = isRootCategory() ? '' : `${categoryNames}_${getCategoryId()}`;
        const page_cat3 = isRootCategory() || isCategoryLvlTwo() ? '' : breadcrumbs.join(',');
        setVariables(
            {
                env_template: 'category',
                sales_insights: '1',
                page_name: isRootCategory()
                    ? 'All-products-and-services-page'
                    : `${page_cat1}${page_cat3 ? `_${page_cat3}` : ''}${
                          page_cat2 ? `_${page_cat2}` : ''
                      }`,
                page_cat1,
                page_cat2,
                page_cat3,
                page_level: '89',
            },
            isReloadNeeded,
        );
    } catch (err) {
        console.error(err);
    }
};

class CategoryAnalytics extends Analytics {
    constructor() {
        super();
        this.PAGE = PAGE;
    }

    observerSetVariables = mutationsList => {
        try {
            // eslint-disable-next-line
            for (const mutation of mutationsList) {
                const breadcrumbsAttr = mutation.target.dataset.breadcrumbs;
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-breadcrumbs' &&
                    breadcrumbsAttr !== mutation.oldValue
                ) {
                    setVariablesHandler();
                    this.setObserverProductsChanged();
                    break;
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
    handleEventsClick(e) {
        super.handleEventsClick(e);
        const { target } = e;
        if (matchThisOrChildren(target, HELP_ME_CHOOSE_BTN_SELECTOR)) {
            this.helpMeChoose(target);
        } else if (matchThisOrChildren(target, SUBCATEGORY_SELECTOR)) {
            this.subCategoryLink(target);
        } else if (matchThisOrChildren(target, CATEGORY_CARD_SELECTOR)) {
            this.categoryCard(target);
        } else if (matchThisOrChildren(target, RELATED_MEDIA_SELECTOR)) {
            this.video(target);
        } else if (matchThisOrChildren(target, FIND_RESELLER_SELECTOR)) {
            this.findReseller(target);
        } else if (matchThisOrChildren(target, SUPPORT_BTN_SELECTOR)) {
            this.support(target);
        } else if (matchThisOrChildren(target, TAB_SELECTOR)) {
            this.tab(target);
        } else if (matchThisOrChildren(target, QUICK_LINK_SELECTOR)) {
            this.quickLink(target);
        } else if (matchThisOrChildren(target, HELP_ME_CHOOSE_BANNER)) {
            this.helpMeChooseBanner(target);
        } else if (this.matchThisOrChildren(target, FILTER_PILL_SELECTOR)) {
            this.filterPill(target);
        } else if (this.matchThisOrChildren(target, DOWNLOAD_BTN_SELECTOR)) {
            this.resultCTA(target, DOWNLOAD_LABEL);
        } else if (this.matchThisOrChildren(target, SUPPORT_LINK_SELECTOR)) {
            this.supportServiceLink(target);
        }
    }

    handleEngagementClick(e) {
        super.handleEngagementClick(e);
        const { target } = e;
        if (matchThisOrChildren(target, DOWNLOAD_BTN_SELECTOR)) {
            const block = getClosest(target, RESULT_LIST_ITEM);
            apcLogService(`${PAGE}.downloadEngagement.click`, {
                target,
                format: getCurrentCategory(),
                productId: block.dataset.productId || '',
                url: document.location.href,
            }); // download Engagement 16 ;
        } else if (matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            const block = getClosest(target, RESULT_LIST_ITEM);
            apcLogService(`${PAGE}.addToCartEngagement.click`, {
                target,
                productId: block.dataset.productId || '',
                format: getCurrentCategory(),
                categoryId: getCategoryId(),
                url: document.location.href,
            }); // add to cart Engagement 105 ;
        } else if (matchThisOrChildren(target, FIND_RESELLER_SELECTOR)) {
            apcLogService(`${PAGE}.findResellerEngagement.click`, {
                target,
                isRootCategory: isRootCategory(),
                format: getCurrentCategory(),
                categoryId: getCategoryId(),
                url: document.location.href,
            }); // find a reseller 141 - 145 ;
        } else if (matchThisOrChildren(target, 'a.analytics-compare-now')) {
            apcLogService(`${PAGE}.compareEngagement.click`, {
                target,
                format: getCurrentCategory(),
                categoryId: getCategoryId(),
                url: document.location.href,
            }); // compare 90 - 93 ;
        } else if (matchThisOrChildren(target, HELP_ME_CHOOSE_BTN_SELECTOR)) {
            const selectorName = getClosest(target, 'div[data-selector-name]');
            apcLogService(`${PAGE}.helpMeChooseEngagement.click`, {
                target,
                format: getCurrentCategory(),
                categoryId: getCategoryId(),
                selectorName: selectorName ? selectorName.dataset.selectorName : '',
                url: document.location.href,
            }); // help me chose 77 - 80 ;
        } else if (matchThisOrChildren(target, RELATED_MEDIA_SELECTOR)) {
            const videoName = getClosest(target, '.related-media-analytics[data-video-name]');
            apcLogService(`${PAGE}.videoEngagement.click`, {
                target,
                format: getCurrentCategory(),
                categoryId: getCategoryId(),
                videoName: videoName ? videoName.dataset.videoName : '',
                url: document.location.href,
            }); // video 42 ;
        }
    }

    breadCrumbs(target) {
        const block = getClosest(target, 'li[data-item-name]');
        const { itemName = '', itemType = '' } = (block && block.dataset) || {};
        apcLogService(`${PAGE}.breadCrumbs.click`, {
            target,
            itemName,
            category: itemType,
            currentCategory: capitalize(getCurrentCategory()),
            currentCategoryName: getCurrentCategoryName(),
        }); // breadCrumbs
    }

    subCategoryLink(target) {
        const link = getClosest(target, '.subcategory-analytics[data-subcategory-name]');
        const card = getClosest(target, CATEGORY_CARD_SELECTOR);
        const { subcategoryName = '', category = '' } = link.dataset;
        apcLogService(`${PAGE}.subCategoryLink.click`, {
            target,
            cardCategoryName: card ? card.dataset.categoryName : '',
            linkCategoryName: subcategoryName,
            linkCategoryType: category,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // 97 sub category link
    }

    video(target) {
        const block = getClosest(target, '.related-media-analytics[data-video-name]');
        apcLogService(`${PAGE}.video.click`, {
            target,
            videoName: block ? block.dataset.videoName : '',
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // 115 video
    }

    supportServiceLink(target) {
        const block = getClosest(target, SUPPORT_LINK_SELECTOR);
        const { itemName = '', groupName = '' } = block.dataset || {};
        apcLogService(`${PAGE}.supportServiceLink.click`, {
            target,
            itemName,
            groupName,
            url: block.href,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        });
    }

    tab(target) {
        const block = getClosest(target, TAB_SELECTOR);
        apcLogService(`${PAGE}.tab.click`, {
            target,
            tabName: block ? block.dataset.tabName : '',
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // tab 131, 134 ;
    }

    quickLink(target) {
        const block = getClosest(target, QUICK_LINK_SELECTOR);
        apcLogService(`${PAGE}.quickLink.click`, {
            target,
            itemName: block.dataset.itemName || '',
            url: block.href,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // quick link 119;
    }

    resultCTA(target, type) {
        const block = this.getClosest(target, RESULT_LIST_ITEM);
        const { productId = '' } = block ? block.dataset : {};
        const isDocument = !!this.matches(target, DOWNLOAD_BTN_SELECTOR);
        apcLogService(`${this.PAGE}.resultCTA.click`, {
            target,
            productId,
            type,
            isDocument,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // 1 - 3rd;
    }

    helpMeChooseBanner(target) {
        const link = this.getClosest(target, HELP_ME_CHOOSE_BANNER);
        apcLogService(`${PAGE}.helpMeChooseBanner.click`, {
            target,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
            url: link.href,
        }); // helpMeChooseBanner
    }

    helpMeChoose(target) {
        const card = getClosest(target, CATEGORY_CARD_SELECTOR);
        const btn = getClosest(target, HELP_ME_CHOOSE_BTN_SELECTOR);
        apcLogService(`${PAGE}.helpMeChoose.click`, {
            cardCategoryName: card ? card.dataset.categoryName : '',
            cardCategory: '',
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
            url: btn.href,
        }); // help me chose ;
    }

    support(target) {
        const block = this.getClosest(target, SUPPORT_BTN_SELECTOR);
        apcLogService(`${PAGE}.support.click`, {
            target,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
            url: block.href,
        }); // 157 support
    }

    findReseller(target) {
        const block = this.getClosest(target, FIND_RESELLER_SELECTOR);
        apcLogService(`${PAGE}.findReseller.click`, {
            target,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
            url: block.href,
        }); // 117 find a reseller
    }

    categoryCard(target) {
        const block = getClosest(target, CATEGORY_CARD_SELECTOR);
        const { categoryName = '', category = '' } = block.dataset;
        apcLogService(`${PAGE}.categoryCard.click`, {
            target,
            cardCategoryName: categoryName,
            cardCategory: category,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // 94 category card
    }
    resultItemCompare(target) {
        const block = this.getClosest(target, RESULT_LIST_ITEM);
        const { checked = false } = target;
        const { productId } = (block && block.dataset) || {};
        apcLogService(`${this.PAGE}.resultItemCompare.check`, {
            target,
            checked,
            productId,
            category: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // 12
    }
    resultItem(target) {
        const block = getClosest(target, RESULT_LIST_ITEM);
        apcLogService(`${PAGE}.productResult.click`, {
            target,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
            productId: block ? block.dataset.productId : '',
        }); // product click  143 ;
    }
    sortBy(target) {
        apcLogService(`${this.PAGE}.sortby.select`, {
            name: target.dataset.itemName,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
            target,
        }); // 3;
    }
    clearAll(target) {
        apcLogService(`${this.PAGE}.clearAll.click`, {
            target,
            currentCategory: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // clear all
    }
    filterChanged(target) {
        const block = this.getClosest(target, '.filter-list__abstract-sublist-item');
        const input = block.querySelector('input');
        const selected = input
            ? input.checked
            : !this.matches(target, '.filter-list__sublist-item-cross');
        apcLogService(`${this.PAGE}.filterChanged.click`, {
            target,
            selected,
            filterCategory: getFilterCategoryName(target),
            currentCategory: capitalize(getCurrentCategory()),
            currentCategoryName: getCurrentCategoryName(),
            name: block.dataset.itemName,
        }); // 7;
    }
    filterPill(target) {
        const block = this.getClosest(target, 'li.selected-facets__list-item');
        apcLogService(`${this.PAGE}.filterChanged.click`, {
            target,
            filterCategory: block.dataset.facetTitle || '',
            name: block.dataset.itemName || '',
            selected: false,
            currentCategory: capitalize(getCurrentCategory()),
            currentCategoryName: getCurrentCategoryName(),
        }); // 7;
    }
    compareNow(target) {
        const countElem = document.querySelector('#comparison-widget .analytics-compare-count');
        const count = countElem ? countElem.textContent : '';
        apcLogService(`${this.PAGE}.compareNow.click`, {
            target,
            count,
            category: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        });
    }

    compareClose(target) {
        apcLogService(`${this.PAGE}.compareClose.click`, {
            target,
            category: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        });
    }

    compareClearList(target) {
        apcLogService(`${this.PAGE}.compareClearList.click`, {
            target,
            category: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        });
    }

    chatEngagement(target) {
        apcLogService(`${PAGE}.chatEngagement.click`, {
            target,
            isRootCategory: isRootCategory(),
            format: getCurrentCategory(),
            categoryId: getCategoryId(),
            url: document.location.href,
        }); // chat 153 - 154 ;
    }
    chatOpen(target) {
        const available = !!this.getClosest(target, CHAT_ONLINE_SELECTOR);
        apcLogService(`${this.PAGE}.chat.click`, {
            target,
            available,
            category: capitalize(getCurrentCategory()),
            categoryName: getCurrentCategoryName(),
        }); // chat
    }
}
try {
    preload(PAGE);
    setPageReady(
        getDefaultPageReadyPromise('.apcCategories .se-breadcrumbs').then(() => {
            setVariablesHandler(false);
            const categoryAnalytics = new CategoryAnalytics();
            categoryAnalytics.init();
            const node = document.querySelector('.apcCategories .se-breadcrumbs');
            const config = {
                attributes: true,
                attributeFilter: ['data-breadcrumbs'],
                attributeOldValue: true,
            };
            const observer = new MutationObserver(categoryAnalytics.observerSetVariables);
            observer.observe(node, config);
        }),
    );
} catch (err) {
    console.error(err);
}
